import { call, put, takeLatest } from "redux-saga/effects";
import {
  SG_GET_TAG_TYPES,
  GET_TAG_TYPES,
  SG_FETCH_TAG_TYPE,
  FETCH_TAG_TYPE,
  SG_ADD_TAG_TYPE,
  ADD_TAG_TYPE,
  SG_UPDATE_TAG_TYPE,
  UPDATE_TAG_TYPE,
  SG_DELETE_TAG_TYPE,
  DELETE_TAG_TYPE,
  TAG_TYPES_PENDING,
  ALL_ERRORS,
} from "constants/actions";
import * as api from "constants/api";

function* getTagTypes(action) {
  try {
    yield put({ type: TAG_TYPES_PENDING });
    const response = yield call(api.GET_TAG_TYPES, action.payload);
    yield put({ type: GET_TAG_TYPES, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* fetchTagType(action) {
  try {
    yield put({ type: TAG_TYPES_PENDING });
    const response = yield call(api.FETCH_TAG_TYPE, action.payload);
    yield put({ type: FETCH_TAG_TYPE, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* addTagType(action) {
  try {
    yield put({ type: TAG_TYPES_PENDING });
    const response = yield call(api.ADD_TAG_TYPE, action.payload);
    yield put({ type: ADD_TAG_TYPE, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* updateTagType(action) {
  try {
    yield put({ type: TAG_TYPES_PENDING });
    const response = yield call(api.UPDATE_TAG_TYPE, action.payload);
    yield put({ type: UPDATE_TAG_TYPE, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* deleteTagType(action) {
  try {
    yield put({ type: TAG_TYPES_PENDING });
    yield call(api.DELETE_TAG_TYPE, action.payload);
    yield put({ type: DELETE_TAG_TYPE, payload: action.payload });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export default function* tagTypesSaga() {
  yield takeLatest(SG_GET_TAG_TYPES, getTagTypes);
  yield takeLatest(SG_FETCH_TAG_TYPE, fetchTagType);
  yield takeLatest(SG_ADD_TAG_TYPE, addTagType);
  yield takeLatest(SG_UPDATE_TAG_TYPE, updateTagType);
  yield takeLatest(SG_DELETE_TAG_TYPE, deleteTagType);
}